<template>
    <div class="col-12 col-lg-6" v-if="offlineQuestionnaires.length > 0">
        <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
            <div class="app-card-header p-3 border-bottom-0">
                <div class="row align-items-center gx-3">
                    <div class="col-auto">
                        <div class="app-icon-holder">
                            <svg height="24px" viewBox="0 0 24 24" width="24px" fill="none"  stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <rect stroke="none" fill="none" height="24" width="24"/>
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </g>
                            </svg>
                        </div>

                    </div>
                    <div class="col-auto">
                        <h4 class="app-card-title">{{ __('navigation.sidebar-offline-questionnaires') }}</h4>
                    </div>
                </div>
            </div>
            <div class="app-card-body px-4">

                <div class="intro">{{ __('navigation.intro-offline-questionnaires') }}</div>
            </div>
            <div class="app-card-footer p-4 mt-auto">
                <button type="submit" class="btn app-btn-danger" @click="syncForms()">
				    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
					    <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
					</svg>
					{{ syncButtonText }}
				</button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
	data() {
		return {
			offlineQuestionnaires: this.getFormsFromStorage(),
			syncing: false
		}
	},

	computed: {
		syncButtonText() {
			if (this.syncing) {
				return 'Syncing...';
			} else if (!this.syncing && this.offlineQuestionnaires.length > 0) {
				return this.__('actions.sync') + ' ' + this.offlineQuestionnaires.length + ' ' + this.__('questionnaires.offline');
			} else {
				return this.__('questionnaires.no-offline');
			}
		}
	},

	created() {
		if (localStorage[storageKey] === undefined) {
			localStorage[storageKey] = JSON.stringify([]);
		}
	},

	methods: {
        getFormsFromStorage: function(){
            return JSON.parse(localStorage[storageKey]).filter(value => value.is_draft === false)
        },
		syncForms: async function () {
			// retrieve data waiting to be sent
			if (localStorage[storageKey] === undefined) return;

			if (!navigator.onLine) {
				Toast.fire({icon: 'error', title: this.__('questionnaires.seems-offline')});
				return;
			}

			this.syncing = true;

			let data = this.getFormsFromStorage()

			let total = data.length;

			if (total > 0) {
				// removes empty records
				if (data.length) {
					data.forEach((value, index) => {
						if (value === null) {
							data.splice(index, 1);
						}
					});
				}

				// total = data.length;

				// send forms one by one
				// if it succeeds, we remove the form from the localStorage
				const newData = JSON.parse(JSON.stringify(data));
				console.log(newData)
				for await (const form of JSON.parse(JSON.stringify(data))) {

                    await axios.post(form.url, form.data).then(response => {
                        newData.splice(0, 1);
                        // store the new data.
                        // It should be an empty array if no error occurred.
                        localStorage[storageKey] = JSON.stringify(newData);
                    }).catch(error => {
                        console.log(error);
                        // we remove the form causing the issue
                        // newData.splice(0, 1);
                        // localStorage[storageKey] = JSON.stringify(newData);
                        Toast.fire({icon: 'error', title: error.data.message})
                    });

				}

				this.syncing = false;
				this.offlineQuestionnaires = this.getFormsFromStorage()

				Toast.fire({icon: 'success', title: this.__('questionnaires.all-offline-synced')})
			} else {
				Toast.fire({icon: 'info', title: this.__('questionnaires.no-offline')});
			}
		},
	}
}
</script>
